import { Company } from "../../../../interfaces/company";

const joinParts = (parts: Array<string | undefined | null>, separator = " ") =>
  parts
    .map((part) => (part ? String(part).trim() : ""))
    .filter(Boolean)
    .join(separator);

export const buildCompanyAddress = (empresa?: Company | null) =>
  joinParts([
    empresa?.Address,
    empresa?.Address_2,
    empresa?.City,
    empresa?.County,
    empresa?.Country_Region_Code,
  ]);

export const buildStoreName = (
  selectedTPV?: any,
  invoice?: any,
  caja?: any,
) =>
  selectedTPV?.nombre ||
  (typeof caja === "object" ? caja?.tpvNombre : null) ||
  invoice?.Tienda ||
  invoice?.TPV ||
  "-";

export const buildStoreAddress = (selectedTPV?: any) =>
  joinParts(
    [
      selectedTPV?.direccion,
      selectedTPV?.direccion2,
      selectedTPV?.ciudad,
      selectedTPV?.provincia,
      selectedTPV?.pais,
    ],
    " - ",
  );

export const buildStorePhone = (
  selectedTPV?: any,
  empresa?: Company | null,
) => selectedTPV?.telefono || selectedTPV?.movil || empresa?.Phone_No || "-";

export const buildCustomerName = (invoice?: any, selectedClient?: any) =>
  invoice?.Bill_to_Name ||
  invoice?.Sell_to_Customer_Name ||
  selectedClient?.name ||
  "-";

export const buildCustomerId = (invoice?: any, selectedClient?: any) =>
  invoice?.VAT_Registration_No_ ||
  invoice?.VAT_Registration_No ||
  selectedClient?.Numero_Identificacion_fiscal ||
  "-";

export const buildCustomerAddress = (invoice?: any, selectedClient?: any) =>
  joinParts([
    invoice?.Bill_to_Address || selectedClient?.Direccion,
    invoice?.Bill_to_Address_2 || selectedClient?.Direccion_2,
    invoice?.Bill_to_City || selectedClient?.Poblacion,
    invoice?.Bill_to_County || selectedClient?.Provincia,
  ]);

export const buildMachineNo = (selectedTPV?: any, invoice?: any) =>
  selectedTPV?.No ||
  invoice?.No_Maquina_Registradora ||
  invoice?.Machine_No ||
  "-";

export const buildCashierLabel = (
  invoice?: any,
  currentUser?: any,
  fallback = "T0000001",
) =>
  [
    invoice?.ID_Cajero || currentUser?.No || currentUser?.username || fallback,
    invoice?.Salesperson_Code || "VENDEDOR LIBRERIA",
  ].join(" - ");

export const buildExchangeRate = (invoice?: any) =>
  invoice?.Exchange_Rate_USD ||
  invoice?.Tipo_Cambio ||
  invoice?.T_Cambio ||
  "-";

export const buildEstablishmentCode = (invoice?: any) =>
  invoice?.Establecimiento_Factura ||
  invoice?.Establecimiento ||
  invoice?.Cod_Establecimiento ||
  "0000";
